var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirCompressorTool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 41.9,
    viewBox: "0 0 42 41.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Pfad_401",
    x: 0,
    y: 0.2,
    width: 42,
    height: 41.7,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00c4ff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "AirCompressor",
    x: 6,
    y: 0,
    width: 30,
    height: 35.699,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00c4ff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "COMPRESSOR",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#Pfad_401)",
    transform: "matrix(1, 0, 0, 1, -3, -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_401-2",
    "data-name": "Pfad 401",
    fill: "#f5f5f5",
    d: "M 36 18 A 18.015 18.015 0 0 1 24.372 34.814 V 32.669 A 16.008 16.008 0 1 0 11.472 32.591 V 34.754 A 17.992 17.992 0 1 1 36 18 Z",
    transform: "translate(3 3)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#AirCompressor)",
    transform: "matrix(1, 0, 0, 1, -3, -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "AirCompressor-2",
    "data-name": "AirCompressor",
    className: "cls-1",
    d: "M 28 14.962 A 7 7 0 1 0 21 21.962 A 7.007 7.007 0 0 0 28 14.962 M 26.946 14.962 A 5.946 5.946 0 1 1 21 9.016 A 5.953 5.953 0 0 1 26.946 14.962 M 24.953 12.149 L 22.153 14.949 C 22.153 14.991 22.166 15.031 22.166 15.074 A 1.226 1.226 0 1 1 20.94 13.848 A 1.2 1.2 0 0 1 21.253 13.894 L 23.978 11.168 C 23.985 11.162 23.993 11.16 24 11.154 A 4.877 4.877 0 1 0 24.95 12.154 M 22.65 25.354 V 23.477 H 19.35 V 25.353 H 16.16 V 26.853 H 25.839 V 25.353 Z M 30.534 28.354 H 11.467 V 32.354 H 30.532 Z M 25.841 36.36 H 16.16 V 37.86 H 25.839 Z M 25.841 33.76 H 16.16 V 35.26 H 25.839 Z",
    transform: ""
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirCompressorTool);
export default __webpack_public_path__ + "static/media/air-compressor-tool.4c0639ea27e835886af44c8922497f78.svg";
export { ForwardRef as ReactComponent };